import React from "react";
import styles from "./RepairService.module.scss";

const RepairService: React.FC = () => {
  return (
    <div className="container section">
      <div
        className={`${styles.repairService} sectionContainer sectionContainerWhite bigSection`}
      >
        <div className={`sideP64 titleCont ${styles.mainReviewBlock}`}>
          <div className="titleBlock">
            <h2>So funktioniert unser Reparaturservice für Sie</h2>
          </div>
        </div>
        <div className={`${styles.repairServiceContainer} sideP64`}>
          <div className={styles.stepsContainer}>
            <div className={styles.step}>
              <div className={styles.stepNumber}>01</div>
              <div className={styles.pointBlock}>
                <div className={styles.point}></div>
              </div>
              <div className={styles.stepline}></div>
              <div className={styles.stepContent}>
                <h2 className={styles.stepTitle}>Beratung</h2>
                <p className={styles.stepText}>
                  Kontaktieren Sie uns für eine individuelle Beratung zu Ihrem
                  Anliegen.
                </p>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>02</div>
              <div className={styles.pointBlock}>
                <div className={styles.point}></div>
              </div>
              <div className={styles.stepline}></div>
              <div className={styles.stepContent}>
                <h2 className={styles.stepTitle}>Kostenlose Diagnose</h2>
                <p className={styles.stepText}>
                  Wir prüfen das Bauteil und teilen Ihnen die Ergebnisse sowie
                  die Reparaturkosten mit.
                </p>
              </div>
            </div>

            <div className={styles.step}>
              <div className={styles.stepNumber}>03</div>
              <div className={styles.pointBlock}>
                <div className={styles.point}></div>
              </div>
              <div className={styles.stepContent}>
                <h2 className={styles.stepTitle}>Reparaturfreigabe</h2>
                <p className={styles.stepText}>
                  Nach Ihrer Bestätigung und Bezahlung beginnen wir umgehend mit
                  der Reparatur. Die Reparatur dauert in der Regel 1-2 Werktage.
                </p>
              </div>
            </div>
          </div>
          <div className={styles.imgWrapper}>
            <img
              src="/images/werkstatt-berlin-delivery.webp"
              alt="Reparatur-Service"
              className={styles.headerImage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RepairService;
